'use strict';

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/BackOffice'

import FormElement from '@/Form/toolkit/FormElement'

import DiscountCodeRow from '@/Lists/Rows/DiscountCodeRow'
import Dashboard       from '@/Lists/Dashboard'

import SearchBar from '@Pure/SearchBar'
import Link      from '@Pure/Link'

import DeleteDiscountcodesModal from '@Modal/DeleteDiscountCodesModal'

import { isTrue } from '@root/utility'

const DASHBOARD = 'DiscountCodesList';

let app = window.app;

const status_messages = { };

const header =
[
	{
		label: '',
		name: '_cb',
		sortable: false
	},
	{
		label: 'Nom produit',
		name: 'price_ref',
		sortable: false
	},
	{
		label: 'Référence produit',
		name: 'product_name',
		sortable: false
	},
	{
		label: 'Code',
		name: 'code',
		sortable: false
	},
	{
		label: 'Date limite',
		name: 'limit_date',
		sortable: false
	},
	{
		label: 'Statut',
		name: 'status',
		sortable: false
	},
	{
		label: 'Facture',
		name: 'Bill_PDF',
		sortable: false
	}
];

const fields = header.map(data => data.name);

const fields_with_timeout = ['searched'];

export default PageWrapper(function DiscountCodesDashboardPage (props)
{
	const storage_filters =
	{
		searched: window.localStorage.getItem(DASHBOARD + '.searched') || '',
		used: isTrue(window.localStorage.getItem(DASHBOARD + '.used') || '')
	};

	const search_timeout = useRef();

	const [dashboard_key, setDashboardKey] = useState(0);

	const [instant_filters, setInstantFilters] = useState({ ...storage_filters });

	const handleChange = useCallback(function ({ value, e, name })
	{
		if (e === null && fields_with_timeout.includes(name) === false) return;

	// Prevent on mount trigger
		if (e === null && fields_with_timeout.includes(name)) return;

		window.localStorage.setItem(DASHBOARD + '.' + name, value);

		setInstantFilters(function (filters)
		{
			return { ...filters, [name]: value };
		});

		if (fields_with_timeout.includes(name) === false) return;

		if (search_timeout.current)
		{
			window.clearTimeout(search_timeout.current);
		}

		search_timeout.current = window.setTimeout(function ()
		{
			search_timeout.current = undefined;

			setDelayedFilters(function (delayed_filters)
			{
				return { ...delayed_filters, [name]: value };
			});
		},
		320);
	},
	[]);

	const [delayed_filters, setDelayedFilters] = useState({ ...storage_filters });

	const [modal, setModal] = useState({ });

	const handleFormElChange = useCallback(function (e, data)
	{
		handleChange({ e, ...data });
	},
	[handleChange]);

	const handleSearchChange = useCallback(function (value, data={ }, e)
	{
		handleChange({ value: value || '', name: data?.name, e });
	},
	[handleChange]);

	const openRemoveModal = useCallback(function (e)
	{
		setModal({ open: true, trg: e?.target });
	},
	[]);

	const closeModal = useCallback(function (e)
	{
		setModal({ });
	},
	[]);

	const updateDashboard = useCallback(function ()
	{
		setDashboardKey(key => key+1);
	},
	[]);

	const filters = useMemo(function ()
	{
		const filters =
		{
			searched: delayed_filters.searched,
			used: isTrue(instant_filters.used)
		};

		if (instant_filters.id) filters.id = instant_filters.id;

		return filters;
	},
	[instant_filters, delayed_filters]);

	return (
		<Layout history={ props.history } page_title="Tous les codes importés">

			<div className="page-content">

				<div className="o-grid-4 u-content-between u-items-center
					u-margin-bottom-30">

					<div className="o-grid__item">
						<SearchBar hide_btn={ true }
							placeholder="Ref. produit (exacte)"
							handleChange={ handleSearchChange }
							value={ instant_filters.searched }
							name="searched"
							className="c-searchbar c-searchbar--full-width"
						/>
					</div>

					<div className="o-grid__item u-flex u-items-center">
						<FormElement name="used"
							type="checkbox" data={ instant_filters }
							onChange={ handleFormElChange }
							status={ status_messages }
							label="Utilisé"
							className="u-margin-top-0"
						/>
					</div>

					<div className="o-grid__item u-flex" />

					<div className="o-grid__item u-flex u-content-end
						u-items-center">
						<Link href="/import-codes-promo"
							className="c-btn c-btn--add u-no-margin-top">
							Importer des codes
						</Link>
					</div>

				</div>

				<div className="o-content">

					<Dashboard model="DiscountCode" items-per-page={ 50 }
						url="/dashboard/discount-codes" filters={ filters }
						header={ header } fields={ fields }
						order="ASC" order-by="price.ref"
						disable-sort={ filters.searched ? true : false }
						component={ DiscountCodeRow }
						condensed
						key={ String(dashboard_key || 0) }
					/>

					<div className="u-text-right u-overflow-hidden">
						<button type="button" className="c-btn c-btn--delete
							u-margin-top-25"
							onClick={ openRemoveModal }>
							Supprimer les codes sélectionnés
						</button>
					</div>

				</div>

				<DeleteDiscountcodesModal open={ modal.open }
					trg={ modal.trg }
					onClose={ closeModal }
					onDeletion={ updateDashboard }
				/>

			</div> { /* /page-content */ }

		</Layout>
	);
});